module.exports = __webpack_public_path__ + "assets/crypto-js.9fdc2d95.svg";